import WA from '../../Assets/wander.jpg';
import PO from '../../Assets/polygon.png';
import HAC from '../../Assets/Hack.png';
import DRO from '../../Assets/drop.png';
import CE from '../../Assets/celo.jpg';
import VB from '../../Assets/visualbulletin.jpg';
import VE from '../../Assets/verzeo.png';

const Sponsor = [
    {
        name:'Microsoft Learn Student Ambassador ',
        desc:' Microsoft is an American multinational technology corporation which produces computer software .',
        image:"https://pbs.twimg.com/profile_images/1291658738630373376/JF6q9ruS_400x400.jpg",
    },
    {
        name:'Github',
        desc:'GitHub is a Git repository hosting service Web-based graphical interface. It provides access control and several collaboration features',
        image:"https://pbs.twimg.com/profile_images/1414990564408262661/r6YemvF9_400x400.jpg",
    },
    {
        name:"Geeks For Geeks",
        desc:' A Computer Science portal for geeks. It contains well written, well thought and well explained computer science and programming articles',
        image:"https://media.geeksforgeeks.org/wp-content/uploads/20210101144014/gfglogo.png",
    },
    {
        name:'Coding Blocks',
        desc:'Coding Blocks is the right choice for students looking to sharpen their Coding skills, prepare for Internships or go in for Placements.',
        image:"https://yt3.ggpht.com/ytc/AKedOLR6c_fkcDL8BZYpACLojx7yl4Kirl5z5fAoZKBPlw=s900-c-k-c0x00ffffff-no-rj",
    },
    {
        name:"Merge Intern",
        desc:'Merge Intern acts as a bridge between companies and students having the technical skills and willingness to work in technology companies',
        image:"https://yt3.ggpht.com/ytc/AAUvwnhyk00qm8uO-H3qkGJLLd659nMoG0V-vjk-Odtcq1Y=s900-c-k-c0x00ffffff-no-rj",
    },
    {
        name:'Guerrilla Gaming',
        desc:'Guerilla Gaming is an established name in the online gaming industry. They aim to make online gaming a popular industry in India.',
        image:"https://i.pinimg.com/originals/c5/92/e2/c592e2a7bde60576762fef977611cfa0.png",
    },
    {
        name:'Postman',
        desc:'Postman is an API platform for building and using APIs. Postman simplifies each step of the API lifecycle and streamlines collaboration so you can create better APIs—faster.',
        image:"https://seeklogo.com/images/P/postman-logo-F43375A2EB-seeklogo.com.png",
    },
    {
        name:'Visual Bulletin',
        desc:'Visual Bulletin is the Official Branding society of Thapar University. It has been a publicity and media coverage partner of all the major events that are held in the university',
        image: VB,
    },
    {
        name:'Replit',
        desc:'Repl is an online coding and developing software. It is an online IDE, Editor, Compiler, Interpreter, and REPL(Read-Eval-Print-Loop).',
        image:"https://repl.it/public/images/sm.png",
    },
    {
        name:'Verzeo',
        desc:'Verzeo is an AI based online company that focuses on preparing students for workplaces and corporate culture by providing them with internship opportunities, mentorship programs, and real-life projects.',
        image: VE,
    },
    {
        name:'StickerMule',
        desc:'Sticker Mule is a custom printing company, specializing in stickers, labels, coasters, mailers, acrylic, buttons, pins, packaging, magnets, and hot sauce.',
        image:"https://www.socallinuxexpo.org/sites/default/files/logos/sticker-mule-logo-dark-stacked.png",
    },
    {
        name:"Hack Club",
        desc:'Hack Club is a global network of programming clubs where members learn to code through tinkering and building project',
        image: HAC ,
    },
    {
        name:"Polygon",
        desc:'Polygon is an  easy-to-use platform for Ethereum scaling and infrastructure development for  blockchain networks.',
        image:PO ,
    },
    {
        name:"PrepBytes",
        desc:'PrepBytes is an initiative that provides coding programs to students and also helps in placement preparations targeting Software development companies.',
        image:"https://www.bing.com/th?id=AMMS_aa91f13ef0608b0e2235fcbe5c0a5718&w=110&h=110&c=7&rs=1&qlt=95&pcl=f9f9f9&o=6&cdv=1&dpr=1.25&pid=16.1",
    },
    {
        name:"GiveMyCertificates",
        desc:'GiveMyCertificate is a platform that creates digitized certificates.',
        image:"https://www.bing.com/th?id=AMMS_bef441fa40eae3859a831ccd598a7281&w=110&h=110&c=7&rs=1&qlt=95&pcl=f9f9f9&o=6&cdv=1&dpr=1.25&pid=16.1",
    },
    {
        name:"Major League Hacking",
        desc:'Major League Hacking (MLH) is the official student hackathon league which hosts Hackathon regularly for students to learn.',
        image:"https://www.bing.com/th?id=AMMS_6137da8faef86b14921dd4849b09a2b8&w=110&h=110&c=7&rs=1&qlt=95&pcl=f9f9f9&o=6&cdv=1&dpr=1.25&pid=16.1",
    },
    {
        name:"Coding Ninjas",
        desc:'Coding Ninjas is a platform that provides various courses that are curated by IITians. It is one of the largest online tech education companies in India ',
        image:"https://www.bing.com/th?id=AMMS_6f76e28afce89c0fbf5b0d18d32dfffd&w=110&h=110&c=7&rs=1&qlt=95&pcl=f9f9f9&o=6&cdv=1&dpr=1.25&pid=16.1",
    },
    {
        name:"Grab On",
        desc:'Grab On is a fast-growing platform that provides its users with the best deals and coupons!. It provides offers you cannot resist.        ',
        image:"https://akm-img-a-in.tosshub.com/sites/btmt/images/stories/grabon_660_030317052558.jpg",
    },
    {
        name:"Wanderlooms",
        desc:'Wanderlooms is for all the thrill-lovers & travel- enthusiasts seeking travel infused wardrobe.. It is a "one- stop- shop" for a wide range of travel-related needs.',
        image:WA ,
    },
    {
        name:"Egghead",
        desc:'Egghead is your source for the Badass Portfolio Projects you need to climb the career ladder as a modern web developer.',
        image:"https://www.bing.com/th?id=AMMS_32698e53fce987cf31249fc7ca704504&w=110&h=110&c=7&rs=1&qlt=95&pcl=f9f9f9&o=6&cdv=1&dpr=1.25&pid=16.1",
    },
    {
        name:"Dropout",
        desc:'Dropout Store India is your stop for a wide range of Tees that express you. Here you’ll find premium quality T-shirts and tops that define your personality.',
        image:DRO ,
    },
    {
        name:"Devfolio",
        desc:'Devfolio is the largest and fastest growing community of builders in India. Their mission is to create a thriving community of builders who love making things',
        image:"https://www.bing.com/th?id=AMMS_ddfa5dab86d097962e9e61821eead58c&w=110&h=110&c=7&rs=1&qlt=95&pcl=f9f9f9&o=6&cdv=1&dpr=1.25&pid=16.1",
    },
    {
        name:"Celo",
        desc:'Celo is a mobile-first blockchain optimized for peer-to-peer payments using only a mobile number',
        image: CE,
    },
    {
        name:"Tezos",
        desc:'Tezos is an open-source blockchain protocol for assets and applications',
        image:"https://www.bing.com/th?id=A9348234d77658086e863949868ec0742&w=110&h=110&c=7&rs=1&qlt=80&o=6&dpr=1.25&pid=SANGAM",
    }
]

export default Sponsor;